import { render, staticRenderFns } from "./lkuSalaryitem.vue?vue&type=template&id=47caf193"
import script from "./lkuSalaryitem.vue?vue&type=script&lang=js"
export * from "./lkuSalaryitem.vue?vue&type=script&lang=js"
import style0 from "./lkuSalaryitem.vue?vue&type=style&index=0&id=47caf193&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports